import React from "react";
import { IconExternalLink } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { EPDDetailOUT, Materials2050EPDDetailOUT } from "api-client";

const ExternalLinks = ({
  details,
}: {
  details: Materials2050EPDDetailOUT | EPDDetailOUT | null;
}) => {
  const { t } = useTranslation();

  const externalLinks = [
    {
      title: "2050 Material",
      url: details?.external_links?.materials_2050_source,
    },
    {
      title: t("providers.sentinelHoldingInstitute"),
      url: "",
    },
    {
      title: t("productEditor.epdAsFile"),
      url:
        details?.external_links?.epd_source ??
        details?.external_links?.user_document?.url,
    },
  ];

  if (
    !details?.external_links?.materials_2050_source &&
    !details?.external_links?.epd_source &&
    !details?.external_links?.user_document?.url
  )
    return null;
  return (
    <div className="mb-4">
      <div className="font-semibold text-base mb-3">
        {t("productEditor.externalLinks")}
      </div>
      <div className="flex items-center flex-wrap border-b border-gray-200 pb-2">
        {externalLinks
          .filter((rec) => rec.url)
          .map((item, index) => (
            <div
              key={index}
              className="mr-4 mb-2 text-indigo-700 cursor-pointer flex items-center"
              onClick={() => item.url && window.open(item.url, "_blank")}
            >
              <span className="text-xs font-semibold">{item.title}</span>
              {item.url && (
                <IconExternalLink stroke={3} size={16} className="ml-1.5" />
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default ExternalLinks;
